/* eslint-disable no-nested-ternary */
/* eslint-disable prettier/prettier */
import React, {
  useEffect,
  useRef,
  useCallback,
  useState,
  useMemo,
} from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useRouteMatch, Link } from 'react-router-dom';

import {
  format,
  parseISO,
  isBefore,
  endOfToday,
  isAfter,
  addDays,
} from 'date-fns';

import { Container, Button, Row, Col, Table, Badge } from 'react-bootstrap';

import {
  FaCheckCircle,
  FaPlusCircle,
  FaUser,
  FaTrash,
  FaFile,
  FaGavel,
  FaAddressCard,
  FaHistory,
  FaCalendar,
  FaPhone,
  FaBan,
  FaRegCheckCircle,
  FaEdit,
  FaBarcode,
  FaPrint,
} from 'react-icons/fa';
import Modal from '../../components/Modal';

import api from '../../services/api';

import { useToast } from '../../hooks/toast';
import { useAuth } from '../../hooks/auth';
import { useClinica } from '../../hooks/clinica';

import Loading from '../../components/Loading';

import {
  Card,
  CardHeader,
  CardHeaderCenter,
  CardBody,
  ButtonAdd,
  Cartao,
} from './styles';

import {
  formataCPF,
  formataCNPJ,
  formataIdade,
  formatPrice,
  formataTelefone,
  ORIGEM_PAGAMENTO,
  TIPO_USUARIO,
  SITUACAO_CARTAO,
  TIPO_CARTAO_SAUDE,
  STATUS_TELEMEDICINA,
} from '../../utils/funcoes';

import {
  optionsVencimentoCartao,
  optionsTipoCartao,
} from '../../utils/options';
import Pagamento from '../../components/Pagamento';
import CartaoSaudeAddDependente from '../../components/CartaoSaude/CartaoSaudeAddDependente';
import CartaoSaudeResponsavel from '../../components/CartaoSaude/CartaoSaudeResponsavel';
import CartaoSaudeTitular from '../../components/CartaoSaude/CartaoSaudeTitular';
import CartaoSaudeCancelar from '../../components/CartaoSaude/CartaoSaudeCancelar';
import CartaoSaudeMotivoNaoRenovar from '../../components/CartaoSaude/CartaoSaudeMotivoNaoRenovar';
import CartaoSaudeContrato from '../../components/CartaoSaude/CartaoSaudeContrato';
import ChipTelefonia from '../../components/CartaoSaude/ChipTelefonia';
import Cobranca from '../Relatorios/Cobranca/Cadastro';

import SelectSync from '../../components/SelectSync';
import getResponseErrors from '../../utils/getResponseErrors';
import ComentarioCadastro, {
  IComentario,
  origemComentario,
} from './ComentarioCadastro';
import Boleto, {
  IRetornoBoletoPaciente,
} from '../../components/Pagamento/Boleto';
import Manutencao from '../../components/CartaoSaude/Manutencao';
import { IBeneficio } from '../../hooks/beneficio';
import CartaoSaudeBeneficio from '../../components/CartaoSaude/CartaoSaudeBeneficio';
import PagamentoAssinatura from '../../components/PagamentoAssinatura';
import Telemedicina from '../../components/CartaoSaude/Telemedicina';
import AlterarCartaoAssinatura from '../../components/AlterarCartaoAssinatura';

export interface IPaciente {
  PacCodigo: number;
  PacPessoaFisica: boolean;
  PacNome: string;
  PacNomeSocial: string;
  PacDataNasc: Date;
  PacDataNascFormatada: string;
  PacIdade: string;
  PacCelular: string;
  PacTelefone: string;
  PacCPF: string;
  PacCPFFormatado: string;
  PacRG: string;
  PacCNPJ: string;
  PacCNPJFormatado: string;
  PacContato: string;
  PacTelefonesFormatado: string;
  PacEmail: string;
}

export interface IDependente {
  DepCodigo: number;
  DepPacCodigo: number;
  DepPlaCodigo: number;
  DepParentesco: string;
  DepResponsavel: boolean;
  DepTitular: boolean;
  DepDataInicio: Date;
  DepDataExclusao?: Date;
  DepDataInicioFormatado: string;
  DepDataExclusaoFormatado: string;
  paciente: IPaciente;
}

export interface IParcelas {
  CprCodigo: number;
  CprCodOrigem: number;
  CprOrigem: number;
  CprCatCodigo: number;
  CprDataVenc: Date;
  CprValor: number;
  CprNParcela: number;
  CprPago: boolean;
  CprExcluida: boolean;
  CprHistorico: string;
  CprDataPag?: Date;
  CprValorPag: number;
  CprClinica: number;
  CprParcelaAtiva: boolean;
  CprDataVencFormatado: string;
  CprDataPagFormatado: string;
  CprValorFormatado: string;
  CprValorPagFormatado: string;
  CprPagoFormatado: string;
  CprAtrasada: boolean;
  CprChave?: string;
  atualizado?: boolean;
  codigoBarras?: string;
  linhaDigitavel?: string;
  qrcodebase64?: string;
  boleto?: IRetornoBoletoPaciente;
}

interface ICobranca {
  CobCodigo: number;
  CobObservacao: string;
  CobData: Date;
  CobDataFormatado: string;
  CobDataAviso: Date;
  CobDataAvisoFormatado: string;
  CobTipo: string;
  CobUsuNome: string;
}

export interface ICartaoSaude {
  PlaCodigo: number;
  PlaNumero: string;
  PlaValor: number;
  PlaDataInicio: Date;
  PlaDataFim: Date;
  PlaDiaVencimento: number;
  PlaStatus: boolean;
  PlaSituacao: 0 | 1 | 2 | 3 | 6;
  PlaClinica: number;
  PlaRenovado: boolean;
  PlaContratoAssinado: boolean;
  PlaTipo: number;
  ehEmpresarial: boolean;
  dependentes: IDependente[];
  comentarios: IComentario[];
  cobrancas: ICobranca[];
  beneficios: IBeneficio[];
  parcelas: IParcelas[];
  motivoCancelamento: string;
  motivoNaoRenovar: string;
  PlaDataInicioFormatado: string;
  PlaDataFimFormatado: string;
  statusFormatado: string;
  color: string;
  PlaMotCodigo: number;
  PlaMotData: Date;
  PlaMotDataFormatado: string;
  PlaMotDescricao: string;
  PlaMotUsuCodigo: number;
  PlaCanCodigo: number;
  PlaCanData: Date;
  PlaCanDataFormatado: string;
  PlaCanDescricao: string;
  PlaCanUsuCodigo: number;
  podeRenovar: boolean;
  msgRenovar: string;
  podeCancelar: boolean;
  novo: boolean;
  geraContrato: {
    addDependente: boolean;
    removeDependente: boolean;
    alteraResponsavel: boolean;
    alteraTitular: boolean;
  };
  updated_at: Date;
  boletos: IRetornoBoletoPaciente[];
  telemedicina?: ITelemedicina[];
}

export interface ITelemedicina {
  TelCodigo: number;
  TelPlaCodigo: number;
  nomePaciente?: string;
  TelPacCodigo: number;
  TelCPF: string;
  TelDataFim: Date;
  TelDataFimFormatado?: string;
  TelStatus: number;
  TelChave: string;
  TelCliCodigo: number;
  TelUsuCodigo: number;
  created_at: Date;
  dataInicioFormatado?: string;
  updated_at: Date;
  statusFormatado?: string;
}


export interface IDadosPagamento {
  tituloPagamento: string;
  pagamentoSelecionado?: number;
  codOrigem?: number;
  atualizarCartao?: boolean,
}

interface IRetornoBoleto {
  cprCodigo: number;
  link: string;
}


interface IUrlParams {
  id: string;
}

const formatParcelas = (
  parcelas: IParcelas[],
  boletos: IRetornoBoletoPaciente[],
): {
  parcelasFormatadas: IParcelas[];
  codigoAtrasadas: number[];
} => {
  const codigoAtrasadas: number[] = [];
  const parcelasFormatadas = parcelas.map((parc: IParcelas) => {
    const atrasada =
      parc.CprPago === false &&
      isBefore(parseISO(parc.CprDataVenc.toString()), endOfToday());

    if (atrasada) codigoAtrasadas.push(parc.CprCodigo);

    const dataPagFormatada = parc.CprDataPag
      ? format(parseISO(parc.CprDataPag.toString()), 'dd/MM/yyyy')
      : '';

    const CprDataVenc = parseISO(parc.CprDataVenc.toString());

    return {
      ...parc,
      CprDataVenc,
      CprDataVencFormatado: format(CprDataVenc, 'dd/MM/yyyy'),
      CprDataPagFormatado: !atrasada ? dataPagFormatada : 'Atrasada',
      CprValorFormatado: formatPrice(parc.CprValor),
      CprValorPagFormatado: formatPrice(parc.CprValorPag),
      CprPagoFormatado: parc.CprPago === true ? 'Sim' : 'Não',
      CprAtrasada: atrasada,
      boleto: boletos.find(
        (bol: IRetornoBoletoPaciente) => bol.CprCodigo === parc.CprCodigo,
      ),
    };
  });

  return { parcelasFormatadas, codigoAtrasadas };
};

const formatarTelemedicina = (
  telemedicina: ITelemedicina[],
  dependentes: IDependente[],
): ITelemedicina[] => {
  return telemedicina
    .map((tm: ITelemedicina) => {
      const nomePaciente =
        dependentes.find(
          (dep: IDependente) => dep.DepPacCodigo === tm.TelPacCodigo,
        )?.paciente.PacNome || '';

      return {
        ...tm,
        TelDataFimFormatado: tm.TelDataFim
          ? format(parseISO(tm.TelDataFim.toString()), 'dd/MM/yyyy')
          : '',
        dataInicioFormatado: tm.created_at
          ? format(parseISO(tm.created_at.toString()), 'dd/MM/yyyy')
          : '',
        nomePaciente,
        statusFormatado:
          STATUS_TELEMEDICINA[
          tm.TelStatus as keyof typeof STATUS_TELEMEDICINA
          ],
      };
    })
    .filter((tm: ITelemedicina) => tm.TelStatus > 0);
};

const situacaoCartao = {
  0: 'INATIVO - Cancelado',
  1: 'INATIVO - Cancelado',
  2: 'INATIVO - Expirado',
  3: 'INATIVO - Atrasado',
  6: 'Ativo',
  7: 'Não localizado',
};

const CartaoSaudeDetalhe: React.FC = () => {
  const { addToast } = useToast();
  const { user, clinica } = useAuth();
  const { imagensClinica } = useClinica();

  const { params } = useRouteMatch<IUrlParams>();
  const { id } = params;

  const plaCodigo = useMemo(() => (id ? Number(id) : undefined), [id]);
  const ehAdmin = useMemo(() => user.UsuTipo === TIPO_USUARIO.ADMINISTRADOR, [user.UsuTipo]);
  const ehGerente = useMemo(() => user.UsuTipo === TIPO_USUARIO.SUPERVISOR, [user.UsuTipo]);
  const [plano, setPlano] = useState<ICartaoSaude | undefined>();
  const [titular, SetTitular] = useState<IDependente>();
  const [responsavel, SetResponsavel] = useState<IDependente | undefined>();
  const [dependentesAtivos, SetDependentesAtivos] = useState<
    IDependente[] | undefined
  >();
  const [dependentesExcluidos, SetDependentesExcluidos] = useState<
    IDependente[] | undefined
  >();
  const [parcelasAtivas, SetParcelasAtivas] = useState<
    IParcelas[] | undefined
  >();
  const [parcelasInativas, SetParcelasInativas] = useState<
    IParcelas[] | undefined
  >();

  const [parcelasManutencao, SetParcelasManutencao] = useState<
    IParcelas[] | undefined
  >();
  const [
    codigosParcelasAtrasadas,
    setCodigosParcelasAtrasadas,
  ] = useState<string>();
  const [comentarios, SetComentarios] = useState<IComentario[]>([]);
  const [cobrancas, setCobrancas] = useState<ICobranca[] | undefined>();
  const [telemedicina, setTelemedicina] = useState<ITelemedicina[] | undefined>();
  const [loading, setLoading] = useState(false);
  const [contratosAssinados, setContratosAssinados] = useState(true);
  const [showModalPagamento, setShowModalPagamento] = useState(false);
  const [
    showModalPagamentoAssinatura,
    setShowModalPagamentoAssinatura,
  ] = useState(false);
  const [
    showModalTrocaCartaoAssinatura,
    setShowModalTrocaCartaoAssinatura,
  ] = useState(false);
  const [showModalAddDependente, setShowModalAddDependente] = useState(false);
  const [showModalResponsavel, setShowModalResponsavel] = useState(false);
  const [showModalBeneficio, setShowModalBeneficio] = useState(false);
  const [showModalTitular, setShowModalTitular] = useState(false);
  const [showModalVencimento, setShowModalVencimento] = useState(false);
  const [showModalComentario, setShowModalComentario] = useState(false);
  const [showModalCancelaCartao, setShowModalCancelaCartao] = useState(false);
  const [showModalMotivonaorenovar, setShowModalMotivonaorenovar] = useState(
    false,
  );
  const [showModalManutencao, setShowModalManutencao] = useState(false);
  const [showModalContratos, setShowModalContratos] = useState(false);
  const [codigoDependenteExcluir, setCodigoDependenteExcluir] = useState<
    number | undefined
  >(undefined);
  const [showBotaoPagamento, setShowBotaoPagamento] = useState(true);
  const [showModalCobranca, setShowModalCobranca] = useState(false);
  const [dadosPagamento, setDadosPagamento] = useState<
    IDadosPagamento | undefined
  >();

  const optionVencimento = useMemo(() => {
    if (clinica.CliDrSaude)
      // dr saude
      return [
        {
          value: '5',
          label: '5',
        },
        {
          value: '20',
          label: '20',
        },
      ];
    return optionsVencimentoCartao;
  }, [clinica.CliDrSaude]);

  const logoCartao =
    imagensClinica.find(img => img.nome === 'logoCartao')?.arquivo_url || '';

  const cliSaoPaulo = !!imagensClinica.find(img => img.nome === 'saopaulo');

  const formRefVencimento = useRef<FormHandles>(null);

  const handleFormataDependentes = useCallback(
    (dependentes: IDependente[], ehEmpresarial: boolean) => {
      const dependentesFormatado = dependentes.map(dep => ({
        ...dep,
        DepDataInicioFormatado: format(
          parseISO(dep.DepDataInicio.toString()),
          'dd/MM/yyyy',
        ),
        DepDataExclusaoFormatado: dep.DepDataExclusao
          ? format(parseISO(dep.DepDataExclusao.toString()), 'dd/MM/yyyy')
          : '',
        paciente: {
          ...dep.paciente,
          PacCPFFormatado: formataCPF(dep.paciente.PacCPF),
          PacCNPJFormatado: formataCNPJ(dep.paciente.PacCNPJ),
          PacDataNascFormatada: dep.paciente.PacPessoaFisica
            ? format(
              parseISO(dep.paciente.PacDataNasc.toString()),
              'dd/MM/yyyy',
            )
            : '01/01/1990',
          PacIdade: dep.paciente.PacPessoaFisica
            ? formataIdade(parseISO(dep.paciente.PacDataNasc.toString()))
            : '0',
          PacTelefonesFormatado:
            dep.paciente.PacTelefone && dep.paciente.PacTelefone.length > 0
              ? `${formataTelefone(
                dep.paciente.PacCelular,
              )} - ${formataTelefone(dep.paciente.PacTelefone)}`
              : formataTelefone(dep.paciente.PacCelular),
        },
      }));

      SetTitular(
        ehEmpresarial === false
          ? dependentesFormatado.find(
            dep => dep.DepTitular && !dep.DepDataExclusao,
          )
          : dependentesFormatado.find(
            dep => dep.DepResponsavel && !dep.DepDataExclusao,
          ),
      );
      SetResponsavel(
        dependentesFormatado.find(
          dep => dep.DepResponsavel && !dep.DepDataExclusao,
        ),
      );
      SetDependentesAtivos(
        dependentesFormatado.filter(
          dep => !dep.DepResponsavel && !dep.DepTitular && !dep.DepDataExclusao,
        ),
      );
      SetDependentesExcluidos(
        dependentesFormatado.filter(dep => dep.DepDataExclusao),
      );
    },
    [],
  );

  const handleFormataDadosCartao = useCallback(
    (dados: ICartaoSaude) => {
      const parcela1 = dados.parcelas.find(
        pac =>
          pac.CprPago &&
          pac.CprParcelaAtiva &&
          !pac.CprExcluida &&
          pac.CprNParcela === 1,
      );

      const dataParcela1 = parcela1
        ? addDays(parseISO(parcela1.CprDataVenc.toString()), -1)
        : new Date();

      const parcelasPagas = dados.parcelas.filter(
        pac =>
          pac.CprPago &&
          pac.CprParcelaAtiva &&
          !pac.CprExcluida &&
          pac.CprNParcela < 13 &&
          isAfter(parseISO(pac.CprDataVenc.toString()), dataParcela1),
      ).length;

      setShowBotaoPagamento(
        parcelasPagas !== 11 ||
        (parcelasPagas === 11 && dados.PlaMotCodigo > 0) ||
        !dados.podeRenovar,
      );


      const { parcelasFormatadas, codigoAtrasadas } = formatParcelas(
        dados.parcelas,
        dados.boletos || [],
      );

      if (codigoAtrasadas.length > 0) {
        setCodigosParcelasAtrasadas(codigoAtrasadas.join(','));
      }

      const tipoCartaotexto =
        optionsTipoCartao.find(opt => opt.value === dados.PlaTipo.toString())
          ?.label || 'NORMAL';

      const ehEmpresarial = tipoCartaotexto.includes('EMPRESA');

      const planoFormatado = {
        ...dados,
        parcelas: parcelasFormatadas,
        ehEmpresarial,
        PlaDataInicio: parseISO(dados.PlaDataInicio.toString()),
        PlaDataInicioFormatado: format(
          parseISO(dados.PlaDataInicio.toString()),
          'dd/MM/yyyy',
        ),
        PlaDataFimFormatado: format(
          parseISO(dados.PlaDataFim.toString()),
          'dd/MM/yyyy',
        ),
        statusFormatado: situacaoCartao[dados.PlaSituacao || 7],
        // statusFormatado: handleStatusCartao(dados.PlaSituacao),
        // PlaRenovado: dados.PlaRenovado
        PlaCanDataFormatado: dados.PlaCanData
          ? format(parseISO(dados.PlaCanData.toString()), 'dd/MM/yyyy')
          : '',
        PlaMotDataFormatado: dados.PlaMotData
          ? format(parseISO(dados.PlaMotData.toString()), 'dd/MM/yyyy')
          : '',
      };

      setPlano(planoFormatado);

      setContratosAssinados(planoFormatado.PlaContratoAssinado);

      handleFormataDependentes(
        planoFormatado.dependentes,
        planoFormatado.ehEmpresarial,
      );

      SetParcelasAtivas(
        parcelasFormatadas.filter(
          parc => parc.CprParcelaAtiva && !parc.CprExcluida,
        ),
      );

      SetParcelasInativas(
        parcelasFormatadas.filter(
          parc => !parc.CprParcelaAtiva && !parc.CprExcluida,
        ),
      );

      SetParcelasManutencao(
        parcelasFormatadas.map(par => {
          return {
            ...par,
            CprHistorico: par.CprHistorico.replace('CARTÃO SAÚDE ', ''),
          };
        }),
      );

      SetComentarios(
        dados.comentarios.map(com => ({
          ...com,
          ComDataFormatado: format(
            parseISO(com.ComData.toString()),
            'dd/MM/yyyy',
          ),
          ComDataAvisoFormatado: com.ComDataAviso
            ? format(parseISO(com.ComDataAviso.toString()), 'dd/MM/yyyy')
            : '',
          ComOrigemTexto: origemComentario[com.ComOrigem || 0],
        })),
      );

      setCobrancas(
        dados.cobrancas.map(cob => ({
          ...cob,
          CobDataFormatado: format(
            parseISO(cob.CobData.toString()),
            'dd/MM/yyyy',
          ),
          CobDataAvisoFormatado: cob.CobDataAviso
            ? format(parseISO(cob.CobDataAviso.toString()), 'dd/MM/yyyy')
            : '',
        })),
      );


      if (dados.telemedicina && dados.telemedicina.length > 0) {
        const telemedicinaFormatado = formatarTelemedicina(
          dados.telemedicina,
          planoFormatado.dependentes,
        );

        setTelemedicina(telemedicinaFormatado);
      }



    },
    [handleFormataDependentes],
  );

  const handleAddedTelemedicina = useCallback(
    (dados: ITelemedicina) => {
      setTelemedicina(state => {
        if (state) return [...state.filter(st => st.TelCodigo !== dados.TelCodigo), dados];
        return [dados];
      });
    },
    [],
  );
  const loadDados = useCallback(
    async (codigoPlano: number): Promise<void> => {
      setLoading(true);
      try {
        const response = await api.get<ICartaoSaude>(`/planos/${codigoPlano}`);

        handleFormataDadosCartao(response.data);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar cartão',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [handleFormataDadosCartao, addToast],
  );

  useEffect(() => {
    if (plaCodigo && plaCodigo > 0) loadDados(plaCodigo);
  }, [plaCodigo, loadDados]);

  useEffect(() => {
    document.title = plano?.PlaNumero ? `Cartão #${plano.PlaNumero}` : 'Cartão';
  }, [plano?.PlaNumero]);

  const handlePagamento = useCallback(
    (titulo: string, cprCodigo?: number, cprCodOrigem?: number) => {
      setDadosPagamento({
        tituloPagamento: titulo,
        pagamentoSelecionado: cprCodigo,
        codOrigem: cprCodOrigem,
      });

      setShowModalPagamento(true);
    },
    [],
  );

  const handlePagamentoAssinatura = useCallback(
    ({ tituloPagamento, pagamentoSelecionado, codOrigem, atualizarCartao }: IDadosPagamento) => {
      setDadosPagamento({
        tituloPagamento,
        pagamentoSelecionado,
        codOrigem,
        atualizarCartao,
      });

      setShowModalPagamentoAssinatura(true);
    },
    [],
  );

  const handleFecharModalPagamento = useCallback(
    async (load: boolean) => {
      setShowModalPagamento(false);
      if (load) {
        setLoading(true);

        await loadDados(Number(id));

        setDadosPagamento(undefined);
        setLoading(false);
      }
    },
    [id, loadDados],
  );


  const handleFecharModalPagamentoAssinatura = useCallback(
    async (load: boolean) => {
      setShowModalPagamentoAssinatura(false);
      setShowModalTrocaCartaoAssinatura(false);
      if (load) {
        setLoading(true);

        await loadDados(Number(id));

        setDadosPagamento(undefined);
        setLoading(false);
      }
    },
    [id, loadDados],
  );

  const handleAlteraDiaVencimento = useCallback(
    async (dados: { vencimento: string }) => {
      setLoading(true);
      const { vencimento } = dados;
      try {
        if (!vencimento || vencimento.length === 0) {
          formRefVencimento.current?.setFieldError(
            'vencimento',
            'Selecione um dia',
          );
          return;
        }
        if (Number(vencimento) === plano?.PlaDiaVencimento) {
          addToast({
            title: 'Escolha um vencimento diferente do atual',
            type: 'error',
          });
          return;
        }

        const response = await api.put<ICartaoSaude>(
          `planos/alteravencimento/${plaCodigo}`,
          {
            NovoDiaVencimento: vencimento,
            updated_at: plano?.updated_at,
          },
        );
        setShowModalVencimento(false);
        handleFormataDadosCartao(response.data);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível atualizar o titular',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [
      plaCodigo,
      addToast,
      plano?.PlaDiaVencimento,
      plano?.updated_at,
      handleFormataDadosCartao,
    ],
  );

  const handleRenovarPlano = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.put<ICartaoSaude>(
        `planos/renovar/${plaCodigo}`,
        { updated_at: plano?.updated_at },
      );
      // setShowModalVencimento(false);
      handleFormataDadosCartao(response.data);
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível renovar o cartão',
        type: 'error',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [plaCodigo, plano?.updated_at, addToast, handleFormataDadosCartao]);

  const exibeBotaoRemoverExpirado = useMemo(() => {
    return (
      (ehAdmin || (ehGerente && !clinica.CliDrSaude)) &&
      plano?.PlaSituacao === SITUACAO_CARTAO.EXPIRADO
    );
  }, [plano?.PlaSituacao, ehAdmin, ehGerente, clinica.CliDrSaude]);

  const handleDeleteDependente = useCallback(
    async (DepCodigo: number) => {
      setLoading(true);
      setCodigoDependenteExcluir(undefined);
      try {
        const rota = exibeBotaoRemoverExpirado
          ? 'dependentesexpirado'
          : 'dependentes';
        await api.delete<ICartaoSaude>(
          `planos/${rota}/${plaCodigo}?DepCodigo=${DepCodigo}&updated_at=${plano?.updated_at}`,
        );

        await loadDados(Number(plaCodigo));
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível excluir o dependente',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [
      plaCodigo,
      plano?.updated_at,
      addToast,
      loadDados,
      exibeBotaoRemoverExpirado,
    ],
  );

  const handleGeraBoletos = useCallback(async () => {
    setLoading(true);
    try {
      if (plaCodigo) {
        const retornoBoletos = await api.patch<IRetornoBoleto[]>(
          `/caixa/gerarboletos/${plaCodigo}`,
        );

        if (retornoBoletos.data.length > 0)
          SetParcelasAtivas(state => {
            return state?.map(st => {
              return { ...st, atualizado: !st.atualizado };
            });
          });
        // await loadDados(plaCodigo);
      }
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível gerar boletos',
        type: 'error',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [plaCodigo, addToast]);

  const exibeBotoesEdicao = useMemo(() => {
    return (
      (plano?.PlaStatus ||
        plano?.novo ||
        ehAdmin ||
        (ehGerente && !clinica.CliDrSaude)) &&
      (plano?.PlaSituacao === SITUACAO_CARTAO.ATRASADO ||
        plano?.PlaSituacao === SITUACAO_CARTAO.EMDIA) &&
      (plano?.novo ||
        (!plano?.novo &&
          plano?.PlaTipo !== TIPO_CARTAO_SAUDE.NORMAL_SEIS_MESES &&
          plano?.PlaTipo !== TIPO_CARTAO_SAUDE.ASSINATURA &&
          plano?.PlaTipo !== TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO
        ))
    );
  }, [
    plano?.PlaStatus,
    plano?.PlaSituacao,
    plano?.novo,
    plano?.PlaTipo,
    ehAdmin,
    ehGerente,
    clinica.CliDrSaude,
  ]);

  const handleRetornoComentario = useCallback((comentario: IComentario) => {
    SetComentarios(state => [...state, comentario]);
    setShowModalComentario(false);
  }, []);

  const handlerShowModalManutencao = useCallback(() => {
    // SetComentarios(state => [...state, comentario]);
    setShowModalManutencao(true);
  }, []);

  const handleAssinouContrato = useCallback((contratoAssinado: boolean) => {
    setContratosAssinados(contratoAssinado);
  }, []);

  const exiteParcelaPaga = useMemo(() => {

    const parcelasAll = [...(parcelasAtivas || []), ...(parcelasInativas || [])];

    return (
      parcelasAll.filter(parc => parc.CprPago === true).length > 0
    );
  }, [parcelasAtivas, parcelasInativas]);


  return (
    <Container fluid className="mt-2">
      {loading && <Loading />}

      {showModalAddDependente && plano && (
        <Modal
          show={showModalAddDependente}
          titulo="Adicionar Dependente"
          handleFecharModal={() => setShowModalAddDependente(false)}
        >
          <CartaoSaudeAddDependente
            PlaCodigo={plano.PlaCodigo}
            updated_at={plano.updated_at}
            handleFecharComponent={dados => {
              setShowModalAddDependente(false);
              handleFormataDadosCartao(dados);
            }}
            assinaturaComAdesao={plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO}
          />
        </Modal>
      )}
      {showModalResponsavel && plano && (
        <Modal
          show={showModalResponsavel}
          titulo="Responsável"
          handleFecharModal={() => setShowModalResponsavel(false)}
        >
          <CartaoSaudeResponsavel
            PlaCodigo={plano.PlaCodigo}
            updated_at={plano.updated_at}
            responsavel={responsavel}
            geraNovoContrato={plano.geraContrato.alteraResponsavel}
            handleSalvouResponsavel={dependentes => {
              handleFormataDependentes(dependentes, plano.ehEmpresarial);
              setShowModalResponsavel(false);
            }}
            handleRemoveuResponsavel={() => {
              SetResponsavel(undefined);
              setShowModalResponsavel(false);
            }}
          />
        </Modal>
      )}
      {showModalBeneficio && plano && (
        <Modal
          show={showModalBeneficio}
          titulo="Benefícios"
          handleFecharModal={() => setShowModalBeneficio(false)}
        >
          <CartaoSaudeBeneficio
            PlaCodigo={plano.PlaCodigo}
            CartaoNovo={plano.novo}
            updated_at={plano.updated_at}
            handleFecharComponent={dados => {
              setShowModalBeneficio(false);
              handleFormataDadosCartao(dados);
            }}
          />
        </Modal>
      )}
      {showModalTitular && plano && (
        <Modal
          show={showModalTitular}
          titulo="Alteração de titular"
          handleFecharModal={() => setShowModalTitular(false)}
        >
          <CartaoSaudeTitular
            PlaCodigo={plano.PlaCodigo}
            updated_at={plano.updated_at}
            dependentes={dependentesAtivos}
            geraNovoContrato={plano.geraContrato.alteraTitular}
            handleSalvouTitular={dependentes => {
              handleFormataDependentes(dependentes, plano.ehEmpresarial);
              setShowModalTitular(false);
            }}
          />
        </Modal>
      )}
      {showModalVencimento && plano && (
        <Modal
          show={showModalVencimento}
          titulo="Alterar dia de vencimento"
          handleFecharModal={() => setShowModalVencimento(false)}
        >
          <Form
            ref={formRefVencimento}
            className="mt-2 pb-5"
            onSubmit={handleAlteraDiaVencimento}
          >
            <SelectSync
              label="Novo dia de vencimento"
              name="vencimento"
              options={optionVencimento}
              handleSelectChange={() => console.log('')}
            />
            <Button
              type="submit"
              className="mt-2"
              variant="success"
              disabled={loading}
            >
              Alterar Dia de Vencimento
            </Button>
          </Form>
        </Modal>
      )}
      {showModalComentario && plano && (
        <Modal
          show={showModalComentario}
          titulo="Novo Comentário"
          handleFecharModal={() => setShowModalComentario(false)}
        >
          <ComentarioCadastro
            handleRetorno={handleRetornoComentario}
            plaCodigo={plano.PlaCodigo}
          />
        </Modal>
      )}

      {showModalCancelaCartao && plano && parcelasAtivas && (
        <Modal
          show={showModalCancelaCartao}
          titulo="Cancelar cartão"
          handleFecharModal={() => setShowModalCancelaCartao(false)}
        >
          <CartaoSaudeCancelar
            CartaoNovo={plano.novo}
            PlaCodigo={plano.PlaCodigo}
            PlaDataInicio={plano.PlaDataInicio}
            PlaValor={plano.PlaValor}
            PlaRenovado={plano.PlaRenovado}
            updated_at={plano.updated_at}
            parcelas={parcelasAtivas}
            handleCancelouCartao={planoCancelado => {
              handleFormataDadosCartao(planoCancelado);
              setShowModalCancelaCartao(false);
            }}
            handleFechar={() => setShowModalCancelaCartao(false)}
          />
        </Modal>
      )}
      {showModalMotivonaorenovar && plano && (
        <Modal
          show={showModalMotivonaorenovar}
          titulo="Motivo não renovar"
          handleFecharModal={() => setShowModalMotivonaorenovar(false)}
        >
          <CartaoSaudeMotivoNaoRenovar
            PlaCodigo={plano.PlaCodigo}
            updated_at={plano.updated_at}
            handleSalvouMotivo={planoAtualizado => {
              handleFormataDadosCartao(planoAtualizado);
              setShowModalMotivonaorenovar(false);
            }}
            handleFechar={() => setShowModalMotivonaorenovar(false)}
          />
        </Modal>
      )}
      {showModalPagamento && (
        <Modal
          show={showModalPagamento}
          titulo={dadosPagamento?.tituloPagamento || ''}
          handleFecharModal={() => setShowModalPagamento(false)}
        >
          <Pagamento
            handleFechar={handleFecharModalPagamento}
            tipo={ORIGEM_PAGAMENTO.CARTAO.toString()}
            cprCodigo={dadosPagamento?.pagamentoSelecionado}
          />
        </Modal>
      )}

      {showModalPagamentoAssinatura && (
        <Modal
          show={showModalPagamentoAssinatura}
          titulo={dadosPagamento?.tituloPagamento || ''}
          handleFecharModal={() => setShowModalPagamentoAssinatura(false)}
        >
          <PagamentoAssinatura
            handleFechar={handleFecharModalPagamentoAssinatura}
            tipo={ORIGEM_PAGAMENTO.CARTAO.toString()}
            cprCodigo={dadosPagamento?.pagamentoSelecionado}
            atualizarCartao={dadosPagamento?.atualizarCartao}
          />
        </Modal>
      )}

      {showModalTrocaCartaoAssinatura && (
        <Modal
          show={showModalTrocaCartaoAssinatura}
          titulo="Trocar cartão assinatura"
          handleFecharModal={() => setShowModalTrocaCartaoAssinatura(false)}
        >
          <AlterarCartaoAssinatura
            handleFechar={handleFecharModalPagamentoAssinatura}
            tipo={ORIGEM_PAGAMENTO.CARTAO.toString()}
            plaCodigo={plano?.PlaCodigo || 0}
          />
        </Modal>
      )}

      {showModalCobranca && plano && codigosParcelasAtrasadas && (
        <Modal
          show={showModalCobranca}
          titulo="Registro de Cobrança"
          handleFecharModal={() => setShowModalCobranca(false)}
        >
          <Cobranca
            dadosCobranca={{
              plaCodigo: plano?.PlaCodigo,
              codigo: codigosParcelasAtrasadas,
            }}
            handleFechar={() => setShowModalCobranca(false)}
          />
        </Modal>
      )}

      {codigoDependenteExcluir && plano && (
        <Modal
          show={!!codigoDependenteExcluir}
          titulo="Remover Dependente"
          handleFecharModal={() => setCodigoDependenteExcluir(undefined)}
        >
          <div className="my-4">
            <h5>Essa operação não poderá ser desfeita.</h5>
            {plano.geraContrato.removeDependente && (
              <div className="alert alert-warning px-3 py-1 mt-2">
                <h5>Atenção!</h5>
                Essa operação írá gerar um novo contrato, começando da parcela 1
                até a 12.
              </div>
            )}
            <Button
              type="submit"
              className="mt-2"
              variant="danger"
              onClick={() => handleDeleteDependente(codigoDependenteExcluir)}
              disabled={loading}
            >
              Prosseguir com a exclusão
            </Button>
            <Button
              type="button"
              className="mt-2 ml-3"
              variant="outline-secondary"
              onClick={() => setCodigoDependenteExcluir(undefined)}
              disabled={loading}
            >
              Voltar
            </Button>
          </div>
        </Modal>
      )}

      {showModalContratos && plano && (
        <Modal
          show={showModalContratos}
          titulo="Contratos do Cartão"
          handleFecharModal={() => setShowModalContratos(false)}
        >
          <CartaoSaudeContrato
            PlaCodigo={plano.PlaCodigo}
            handleAssinouContrato={handleAssinouContrato}
          />
        </Modal>
      )}

      {showModalManutencao && parcelasManutencao && (
        <Modal
          show={showModalManutencao}
          titulo="Manutenção de parcelas"
          handleFecharModal={() => {
            setShowModalManutencao(false);
            window.location.reload();
          }}
          large
        >
          <Manutencao parcelas={parcelasManutencao} />
        </Modal>
      )}

      {plano && titular && (
        <>
          <Cartao ativo={plano.novo === true ? true : plano.PlaStatus}>
            <div>
              <img src={logoCartao} alt="Cartão Saúde" />
              <div>
                {plano.ehEmpresarial === false ? (
                  <>
                    <h6>
                      {titular.paciente.PacNomeSocial.trim() !== '' ? (
                        <span>
                          Nome Social: <b>{titular.paciente.PacNomeSocial}</b>
                        </span>
                      ) : (
                        <b>{titular.paciente.PacNome}</b>
                      )}

                      {exibeBotoesEdicao && (
                        <ButtonAdd
                          type="button"
                          onClick={() => setShowModalTitular(true)}
                        >
                          <FaEdit size={15} />
                        </ButtonAdd>
                      )}
                    </h6>

                    <p>
                      <FaCalendar size={13} />{' '}
                      {titular.paciente.PacDataNascFormatada} -{' '}
                      {titular.paciente.PacIdade}
                    </p>
                    <p>
                      <FaPhone size={13} />{' '}
                      {titular.paciente.PacTelefonesFormatado}
                    </p>
                  </>
                ) : (
                  <>
                    <h6>
                      <b>{titular.paciente.PacNome} - PLANO EMPRESA</b>
                    </h6>

                    <p>{`CNPJ ${titular.paciente.PacCNPJFormatado}`}</p>
                    <p>
                      <FaPhone size={13} />{' '}
                      {titular.paciente.PacTelefonesFormatado}{' '}
                      {`Contato: ${titular.paciente.PacContato}`}
                    </p>
                  </>
                )}
              </div>
            </div>
            {cliSaoPaulo && (
              <div className="border-right border-left p-1">
                {responsavel ? (
                  <div>
                    <h6>
                      <b>{responsavel.paciente.PacNome}</b>
                      {exibeBotoesEdicao && plano.ehEmpresarial === false && (
                        <ButtonAdd
                          type="button"
                          onClick={() => setShowModalResponsavel(true)}
                        >
                          <FaEdit size={15} />
                        </ButtonAdd>
                      )}
                    </h6>

                    <p style={{ fontSize: '.8rem' }}>
                      {responsavel.paciente.PacPessoaFisica
                        ? `CPF ${responsavel.paciente.PacCPFFormatado}`
                        : `CNPJ ${responsavel.paciente.PacCNPJFormatado}`}
                      <br />
                      TELEFONE {responsavel.paciente.PacTelefonesFormatado}
                    </p>
                  </div>
                ) : (
                  <div>
                    <p>
                      <b>RESPONSÁVEL</b>
                      {exibeBotoesEdicao && plano.ehEmpresarial === false && (
                        <ButtonAdd
                          type="button"
                          onClick={() => setShowModalResponsavel(true)}
                        >
                          <FaEdit size={15} />
                        </ButtonAdd>
                      )}
                    </p>
                    <br />
                    <p style={{ fontSize: '.8rem' }}>O PRÓPRIO</p>
                  </div>
                )}
              </div>
            )}
            <div style={{ height: '30px', fontSize: '26px' }}>
              {!contratosAssinados && (
                <Badge pill variant="warning">
                  Assinar Contrato
                </Badge>
              )}
            </div>
            <div>
              {plano.PlaStatus ? (
                <FaRegCheckCircle size={50} />
              ) : (
                <FaBan size={50} />
              )}{' '}
              {plano.novo === true ? 'NOVO' : plano.statusFormatado}
            </div>
          </Cartao>

          <Row noGutters className="mb-2">
            <Col sm={12} md={6} lg={2}>
              <Card style={{ height: '100%' }}>
                <h2>
                  <b>CARTÃO</b>
                </h2>
                <CardBody style={{ textAlign: 'center', padding: '10px 5px' }}>
                  <h4>{plano.PlaNumero}</h4>
                  <p>
                    {plano.PlaRenovado && (
                      <b className="text-primary">Renovado</b>
                    )}{' '}
                    ADESÃO {plano.PlaDataInicioFormatado}
                    <br />
                    VALIDADE {plano.PlaDataFimFormatado}
                  </p>
                </CardBody>
              </Card>
            </Col>
            <Col sm={12} md={6} lg={2} className="pl-md-1 mt-2 mt-md-0">
              <Card style={{ height: '100%' }}>
                <CardHeaderCenter>
                  <b>VENCIMENTO</b>
                  {exibeBotoesEdicao && (
                    <ButtonAdd
                      type="button"
                      onClick={() => setShowModalVencimento(true)}
                    >
                      <FaEdit size={15} />
                    </ButtonAdd>
                  )}
                </CardHeaderCenter>

                <CardBody style={{ textAlign: 'center', padding: '10px 5px' }}>
                  <h4>{plano.PlaDiaVencimento}</h4>
                  <p>
                    PRÓXIMA PARCELA
                    <br />
                    {parcelasAtivas &&
                      parcelasAtivas.find(par => par.CprPago === false)
                        ?.CprDataVencFormatado}
                  </p>
                </CardBody>
              </Card>
            </Col>
            {!cliSaoPaulo && (
              <Col sm={12} md={6} lg={3} className="pl-md-1 mt-2 mt-md-0">
                <Card style={{ height: '100%' }}>
                  <CardHeaderCenter>
                    <b>RESPONSÁVEL</b>
                    {exibeBotoesEdicao && plano.ehEmpresarial === false && (
                      <ButtonAdd
                        type="button"
                        onClick={() => setShowModalResponsavel(true)}
                      >
                        <FaEdit size={15} />
                      </ButtonAdd>
                    )}
                  </CardHeaderCenter>

                  <CardBody
                    style={{ textAlign: 'center', padding: '10px 5px' }}
                  >
                    {responsavel ? (
                      <>
                        <h6>{responsavel.paciente.PacNome}</h6>
                        <p style={{ fontSize: '.8rem' }}>
                          {responsavel.paciente.PacPessoaFisica
                            ? `CPF ${responsavel.paciente.PacCPFFormatado}`
                            : `CNPJ ${responsavel.paciente.PacCNPJFormatado}`}
                          <br />
                          TELEFONE {responsavel.paciente.PacTelefonesFormatado}
                        </p>
                      </>
                    ) : (
                      <>
                        <h6>
                          {titular?.paciente.PacNomeSocial.trim() !== '' ? (
                            <>
                              <span className="small">Nome Social: </span>
                              <b>{titular?.paciente.PacNomeSocial}</b>
                            </>
                          ) : (
                            <b>{titular?.paciente.PacNome}</b>
                          )}
                        </h6>
                        <p style={{ fontSize: '.8rem' }}>
                          CPF {titular?.paciente.PacCPFFormatado}
                          <br />
                          TELEFONE {titular?.paciente.PacTelefonesFormatado}
                        </p>
                      </>
                    )}
                  </CardBody>
                </Card>
              </Col>
            )}
            {cliSaoPaulo && (
              <Col sm={12} md={6} lg={3} className="pl-md-1 mt-2 mt-md-0">
                <Card style={{ height: '100%' }}>
                  <CardHeaderCenter>
                    <b>BENEFÍCIOS</b>
                    {exibeBotoesEdicao && plano.ehEmpresarial === false && (
                      <ButtonAdd
                        type="button"
                        onClick={() => setShowModalBeneficio(true)}
                      >
                        <FaEdit size={15} />
                      </ButtonAdd>
                    )}
                  </CardHeaderCenter>

                  <CardBody
                    style={{ textAlign: 'center', padding: '10px 5px' }}
                  >
                    {plano.beneficios.map(ben => (
                      <p className="mb-1">
                        {ben.PbnNome.toUpperCase()} -{' '}
                        <Link
                          style={{ textAlign: 'center' }}
                          to={`/cartaosaudeimpressao/${ben.id}/contratoBeneficio`}
                          target="_blank"
                        >
                          <FaPrint size={16} />
                        </Link>
                        <br />
                      </p>
                    ))}
                    {!plano.beneficios ||
                      (plano.beneficios.length === 0 && (
                        <p className="mb-1">Sem benefícios adicionais</p>
                      ))}
                  </CardBody>
                </Card>
              </Col>
            )}
            <Col sm={12} md={6} lg={3} className="pl-md-1 mt-2 mt-md-0">
              <Card style={{ height: '100%' }}>
                <h2>
                  <b>IMPRESSÕES</b>
                </h2>
                <CardBody style={{ justifyContent: 'center' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-around',
                    }}
                  >
                    <Link
                      style={{ textAlign: 'center' }}
                      to={`/cartaosaudeimpressao/${plaCodigo}/carne`}
                      target="_blank"
                    >
                      <FaFile size={26} />
                      <br />
                      CARNE
                    </Link>
                    <Button
                      className="border-0"
                      size="sm"
                      variant="outline-primary"
                      onClick={() => setShowModalContratos(true)}
                    >
                      <FaGavel size={26} />
                      <br />
                      CONTRATO
                    </Button>
                    <Link
                      style={{ textAlign: 'center' }}
                      to={`/cartaosaudeimpressao/${plaCodigo}/etiqueta`}
                      target="_blank"
                    >
                      <FaAddressCard size={26} />
                      <br />
                      ETIQUETA
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col sm={12} md={6} lg={2} className="pl-md-1 mt-2 mt-md-0">
              <Card style={{ height: '100%' }}>
                <h2>
                  <b>AÇÕES</b>
                </h2>
                <CardBody style={{ justifyContent: 'center' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-around',
                    }}
                  >
                    {!showBotaoPagamento && (
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={() => setShowModalMotivonaorenovar(true)}
                      >
                        Liberar 12º
                      </Button>
                    )}
                    {plano.podeRenovar && (
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={handleRenovarPlano}
                      >
                        Renovar
                      </Button>
                    )}
                    {plano.podeCancelar && (
                      <Button
                        type="button"
                        size="sm"
                        variant="danger"
                        onClick={() => setShowModalCancelaCartao(true)}
                      >
                        Cancelar
                      </Button>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {!showBotaoPagamento && (
            <div className="alert alert-primary p-3 mt-2">
              <h3>
                <b>Lembrete de Renovação</b>
              </h3>
              <p>
                O cartão chegou na sua 11º parcela, para realizar o pagamento da
                12º parcela é necessário que o cartão seja <b>Renovado</b> ou
                que seja inserido um <b>Motivo de não Renovação</b>.
              </p>
            </div>
          )}

          {plano && plano.motivoCancelamento && (
            <div className="alert alert-danger p-3 mt-2">
              Cliente relatou em <b>{plano.PlaCanDataFormatado}</b> que deseja
              cancelar o cartão pelo motivo: <b>{plano.motivoCancelamento}</b> -{' '}
              {plano.PlaCanDescricao}.
            </div>
          )}

          {plano && plano.msgRenovar && plano.msgRenovar.length > 0 && (
            <div className="alert alert-warning p-3 mt-2">
              {plano.msgRenovar}
            </div>
          )}

          {plano && plano.motivoNaoRenovar && (
            <div className="alert alert-info p-3 mt-2">
              Cliente relatou em <b>{plano.PlaMotDataFormatado}</b> que não
              deseja renovar o cartão pelo motivo:{' '}
              <b>{plano.motivoNaoRenovar}</b> - {plano.PlaMotDescricao}.
            </div>
          )}

          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <span>
                    <FaUser size={15} /> <b>DEPENDENTES</b>
                  </span>
                  {exibeBotoesEdicao && !((plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA || plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO) && exiteParcelaPaga) && (
                    <ButtonAdd
                      type="button"
                      onClick={() => setShowModalAddDependente(true)}
                    >
                      <FaPlusCircle size={15} />
                    </ButtonAdd>
                  )}
                </CardHeader>

                <CardBody style={{ height: '241px' }}>
                  <Table className="text-secondary" hover size="sm">
                    <thead>
                      <tr className="bg-light text-dark">
                        <th>Nome</th>
                        <th>Parentesco</th>
                        <th>Data Adesão</th>
                        <th>-</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dependentesAtivos?.map(dep => (
                        <tr key={`dep-${dep.DepCodigo}`}>
                          <td>
                            {dep.paciente.PacNomeSocial !== ''
                              ? `Nome Social: ${dep.paciente.PacNomeSocial}`
                              : dep.paciente.PacNome}
                          </td>
                          <td>{dep.DepParentesco}</td>
                          <td>{dep.DepDataInicioFormatado}</td>
                          <td>
                            {(exibeBotoesEdicao || exibeBotaoRemoverExpirado) &&
                              plano.PlaTipo !== TIPO_CARTAO_SAUDE.SP_SAUDE &&
                              plano.PlaTipo !== TIPO_CARTAO_SAUDE.ASSINATURA && (
                                <Button
                                  data-id={dep.DepCodigo}
                                  type="button"
                                  variant="outline-danger"
                                  size="sm"
                                  style={{ padding: '1px 8px' }}
                                  // eslint-disable-next-line prettier/prettier
                                  onClick={
                                    () =>
                                      setCodigoDependenteExcluir(dep.DepCodigo)
                                    // eslint-disable-next-line react/jsx-curly-newline
                                  }
                                >
                                  <FaTrash size={14} />
                                </Button>
                              )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
              <br />
              <Card>
                <CardHeader>
                  <span>
                    <FaUser size={15} /> <b>HISTÓRICO DE DEPENDENTES</b>
                  </span>
                </CardHeader>

                <CardBody style={{ height: '241px' }}>
                  <Table className="text-secondary" hover size="sm">
                    <thead>
                      <tr className="bg-light text-dark">
                        <th>Nome</th>
                        <th>Parentesco</th>
                        <th>Data Adesão</th>
                        <th>Data Exclusão</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dependentesExcluidos?.map(dep => (
                        <tr key={`depEx-${dep.DepCodigo}`}>
                          <td>
                            {dep.paciente.PacNomeSocial !== ''
                              ? `Nome Social: ${dep.paciente.PacNomeSocial}`
                              : dep.paciente.PacNome}
                          </td>
                          <td>{dep.DepParentesco}</td>
                          <td>{dep.DepDataInicioFormatado}</td>
                          <td>{dep.DepDataExclusaoFormatado}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
            <Col>
              <Card style={{ height: '578px' }}>
                <CardHeader>
                  <span>
                    <FaUser size={15} /> <b>PARCELAS</b>
                  </span>
                  {user.UsuCodigo === 1 && plaCodigo && (
                    <Button
                      data-id={plaCodigo}
                      type="button"
                      size="sm"
                      style={{ padding: '1px 8px' }}
                      className="bg-primary"
                      onClick={() => handlerShowModalManutencao()}
                    >
                      Manutenção
                    </Button>
                  )}
                  {clinica.ConfigBoleto?.Emite && !plano.PlaCanCodigo && (plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA || plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO) && (
                    <Button
                      data-id={plaCodigo}
                      type="button"
                      size="sm"
                      style={{ padding: '1px 8px' }}
                      className="bg-primary"
                      onClick={() => setShowModalTrocaCartaoAssinatura(true)}
                    >
                      Atualizar Cartão
                    </Button>
                  )}

                  {clinica.ConfigBoleto?.Emite && user.UsuCodigo === 1 &&
                    (plano.PlaTipo !== TIPO_CARTAO_SAUDE.ASSINATURA && plano.PlaTipo !== TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO) && (
                      <ButtonAdd
                        type="button"
                        onClick={() => handleGeraBoletos()}
                        title="gerar Boletos"
                      >
                        <FaBarcode size={15} /> Gerar Boletos
                      </ButtonAdd>
                    )}
                </CardHeader>

                <CardBody>
                  <Table
                    className="text-secondary"
                    style={{ marginBottom: '9px' }}
                    hover
                    size="sm"
                  >
                    <thead>
                      <tr className="bg-light text-dark">
                        <th>Histórico</th>
                        <th>Data</th>
                        <th>Pago</th>
                        <th>Data pag.</th>
                        <th>Valor</th>
                        <th>Valor Pago</th>
                        <th>-</th>
                      </tr>
                    </thead>
                    <tbody>
                      {parcelasAtivas?.map(parc => {
                        let corLinha = ''
                        if (parc.CprAtrasada) corLinha = 'text-danger'
                        if (parc.CprPago) corLinha = 'text-success'
                        return (
                          <tr
                            key={`parc-${parc.CprCodigo}`}
                            data-id={parc.CprCodigo}
                            className={`${corLinha}`}
                          >
                            <td>{parc.CprHistorico}</td>
                            <td>{parc.CprDataVencFormatado}</td>
                            <td>{parc.CprPagoFormatado}</td>
                            <td>{parc.CprDataPagFormatado}</td>
                            <td>{parc.CprValorFormatado}</td>
                            <td>{parc.CprValorPagFormatado}</td>
                            <td>
                              <div style={{ display: 'flex' }}>
                                {(plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA || plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO) &&
                                  parc.CprHistorico ===
                                  'ASSINATURA CARTÃO SAÚDE MENSAL' &&
                                  !parc.CprPago && parc.CprNParcela === 1 && (codigosParcelasAtrasadas || '').split(',').length === 1 && (
                                    <Button
                                      data-id={parc.CprCodigo}
                                      title={`btn-pagar-nova-${parc.CprCodigo}`}
                                      type="button"
                                      size="sm"
                                      style={{ padding: '1px 8px' }}
                                      disabled={!showBotaoPagamento}
                                      className={
                                        parc.CprPago
                                          ? 'bg-success'
                                          : 'bg-secondary'
                                      }
                                      // eslint-disable-next-line prettier/prettier
                                      onClick={
                                        () =>
                                          handlePagamentoAssinatura({
                                            tituloPagamento: `Pagar Parcela - ${parc.CprHistorico}`,
                                            pagamentoSelecionado: parc.CprCodigo,
                                            codOrigem: parc.CprCodOrigem,
                                          }
                                          )
                                        // eslint-disable-next-line react/jsx-curly-newline
                                      }
                                    >
                                      <FaCheckCircle size={14} />
                                    </Button>
                                  )}
                                {(plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA || plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO) &&
                                  parc.CprHistorico ===
                                  'ASSINATURA CARTÃO SAÚDE MENSAL' &&
                                  parc.CprAtrasada && parc.CprNParcela !== 1 && (
                                    <Button
                                      data-id={parc.CprCodigo}
                                      title={`btn-pagar-atualizar-${parc.CprCodigo}`}
                                      type="button"
                                      size="sm"
                                      style={{ padding: '1px 8px' }}
                                      disabled={!showBotaoPagamento}
                                      className={
                                        parc.CprPago
                                          ? 'bg-success'
                                          : 'bg-secondary'
                                      }
                                      // eslint-disable-next-line prettier/prettier
                                      onClick={
                                        () =>
                                          handlePagamentoAssinatura({
                                            tituloPagamento: `Pagar Parcela - ${parc.CprHistorico}`,
                                            pagamentoSelecionado: parc.CprCodigo,
                                            codOrigem: parc.CprCodOrigem,
                                            atualizarCartao: true,
                                          }

                                          )
                                        // eslint-disable-next-line react/jsx-curly-newline
                                      }
                                    >
                                      <FaCheckCircle size={14} />
                                    </Button>
                                  )}
                                {(((plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA || plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO) &&
                                  parc.CprHistorico ===
                                  'PARCELA DE ADESÃO DE CARTÃO SAÚDE ASSINATURA' &&
                                  !parc.CprPago && parc.CprNParcela === 1) || (parc.CprHistorico ===
                                    'PARCELA DE ADESÃO DE CARTÃO SAÚDE ASSINATURA' && plano?.novo)) && (
                                    <Button
                                      data-id={parc.CprCodigo}
                                      type="button"
                                      size="sm"
                                      style={{ padding: '1px 8px' }}
                                      disabled={!showBotaoPagamento}
                                      className={
                                        parc.CprPago
                                          ? 'bg-success'
                                          : 'bg-secondary'
                                      }
                                      // eslint-disable-next-line prettier/prettier
                                      onClick={
                                        () =>
                                          handlePagamento(
                                            `Pagar Parcela - ${parc.CprHistorico}`,
                                            parc.CprCodigo,
                                            parc.CprCodOrigem,
                                          )
                                        // eslint-disable-next-line react/jsx-curly-newline
                                      }
                                    >
                                      <FaCheckCircle size={14} />
                                    </Button>
                                  )}

                                {((plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA || plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO) &&
                                  parc.CprHistorico === 'CARTÃO SAÚDE MULTA CONTRATUAL') && (
                                    <>
                                      <Button
                                        data-id={parc.CprCodigo}
                                        type="button"
                                        size="sm"
                                        style={{ padding: '1px 8px' }}
                                        disabled={!showBotaoPagamento}
                                        className={
                                          parc.CprPago
                                            ? 'bg-success'
                                            : 'bg-secondary'
                                        }
                                        // eslint-disable-next-line prettier/prettier
                                        onClick={
                                          () =>
                                            handlePagamento(
                                              `Pagar Parcela - ${parc.CprHistorico}`,
                                              parc.CprCodigo,
                                              parc.CprCodOrigem,
                                            )
                                          // eslint-disable-next-line react/jsx-curly-newline
                                        }
                                      >
                                        <FaCheckCircle size={14} />
                                      </Button>
                                      {clinica.ConfigBoleto?.Emite === true &&
                                        user.UsuCodigo === 1 &&
                                        !parc.CprPago && (plano?.PlaTipo !== TIPO_CARTAO_SAUDE.ASSINATURA &&
                                          plano?.PlaTipo !== TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO) && (
                                          <>
                                            <Boleto
                                              cprCodigo={parc.CprCodigo}
                                              contaPR={{
                                                ...parc,
                                                CprFormaPag: 0,
                                                CprReceita: 0,
                                                CprUsuCodigo: 0,
                                              }}
                                              atualizado={parc.atualizado === true}
                                            />
                                          </>
                                        )}
                                    </>
                                  )}

                                {plano.PlaTipo !==
                                  TIPO_CARTAO_SAUDE.ASSINATURA && plano.PlaTipo !==
                                  TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO && (
                                    <>
                                      <Button
                                        data-id={parc.CprCodigo}
                                        type="button"
                                        size="sm"
                                        style={{ padding: '1px 8px' }}
                                        disabled={!showBotaoPagamento}
                                        className={
                                          parc.CprPago
                                            ? 'bg-success'
                                            : 'bg-secondary'
                                        }
                                        // eslint-disable-next-line prettier/prettier
                                        onClick={
                                          () =>
                                            handlePagamento(
                                              `Pagar Parcela - ${parc.CprHistorico}`,
                                              parc.CprCodigo,
                                              parc.CprCodOrigem,
                                            )
                                          // eslint-disable-next-line react/jsx-curly-newline
                                        }
                                      >
                                        <FaCheckCircle size={14} />
                                      </Button>
                                      {clinica.ConfigBoleto?.Emite === true &&
                                        user.UsuCodigo === 1 &&
                                        !parc.CprPago && (plano?.PlaTipo !== TIPO_CARTAO_SAUDE.ASSINATURA &&
                                          plano?.PlaTipo !== TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO) && (
                                          <>
                                            <Boleto
                                              cprCodigo={parc.CprCodigo}
                                              contaPR={{
                                                ...parc,
                                                CprFormaPag: 0,
                                                CprReceita: 0,
                                                CprUsuCodigo: 0,
                                              }}
                                              atualizado={parc.atualizado === true}
                                            />
                                          </>
                                        )}
                                    </>
                                  )}
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              {!clinica.CliDrSaude && (
                <>
                  {/* plano.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA ||
                    plano?.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO) && (
                      <Telemedicina
                        PlaCodigo={plano.PlaCodigo}
                        dadosTelemedicina={telemedicina || []}
                        exibeBotoesEdicao={
                          (plano?.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA ||
                            plano?.PlaTipo === TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO) && (!codigosParcelasAtrasadas || codigosParcelasAtrasadas === '')
                        }
                        handleFecharComponent={
                          dados => handleAddedTelemedicina(dados)
                          // eslint-disable-next-line react/jsx-curly-newline
                        }
                        dependentes={plano.ehEmpresarial ? (dependentesAtivos || []) : (dependentesAtivos || []).concat(titular)}
                      />
                    )} */}
                  {/* {plano.PlaTipo !== TIPO_CARTAO_SAUDE.ASSINATURA && plano?.PlaTipo !== TIPO_CARTAO_SAUDE.ASSINATURA_COM_ADESAO && ( */}
                  <ChipTelefonia
                    plaCodigo={plano.PlaCodigo}
                    updated_at={plano.updated_at}
                    exibeBotoesEdicao={
                      exibeBotoesEdicao &&
                      plano.PlaTipo !== TIPO_CARTAO_SAUDE.NORMAL_SEIS_MESES &&
                      plano.PlaTipo !== TIPO_CARTAO_SAUDE.SP_SAUDE
                    }
                    handleFecharComponent={
                      dados => handleFormataDadosCartao(dados)
                      // eslint-disable-next-line react/jsx-curly-newline
                    }
                  />
                  {/* )} */}

                </>
              )}
              <Card style={{ marginLeft: '0' }}>
                <CardHeader className="bg-danger">
                  <b>NEGOCIAÇÃO DE PARCELAS ATRASADAS</b>
                  {codigosParcelasAtrasadas && (
                    <ButtonAdd
                      type="button"
                      onClick={() => setShowModalCobranca(true)}
                    >
                      <FaPlusCircle size={15} />
                    </ButtonAdd>
                  )}
                </CardHeader>

                <CardBody style={{ height: '232px' }}>
                  <Table className="text-secondary" hover size="sm">
                    <thead>
                      <tr className="bg-light text-dark">
                        <th>Contato em</th>
                        <th>Colaborador</th>
                        <th>Resposta do Cliente</th>
                        <th>Novo Contato</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cobrancas?.map(cob => (
                        <tr key={`Cob-${cob.CobCodigo}`}>
                          <td>{cob.CobDataFormatado}</td>
                          <td>{cob.CobUsuNome}</td>
                          <td>{cob.CobObservacao}</td>
                          <td>{cob.CobDataAvisoFormatado}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
            <Col>
              <Card>
                <CardHeader>
                  <span>
                    <FaHistory size={15} /> <b>PAGAMENTOS REALIZADOS</b>
                  </span>
                </CardHeader>

                <CardBody
                  style={{ height: clinica.CliDrSaude ? '232px' : '509px' }}
                >
                  <Table className="text-secondary" hover size="sm">
                    <thead>
                      <tr className="bg-light text-dark">
                        <th>Histórico</th>
                        <th>Data</th>
                        <th>Data pag.</th>
                        <th>Valor Pago</th>
                        <th>-</th>
                      </tr>
                    </thead>
                    <tbody>
                      {parcelasInativas?.map(parc => (
                        <tr key={`parc-pago-${parc.CprCodigo}`}>
                          <td>{parc.CprHistorico}</td>
                          <td>{parc.CprDataVencFormatado}</td>
                          <td>{parc.CprDataPagFormatado}</td>
                          <td>{parc.CprValorPagFormatado}</td>
                          <td>
                            <Button
                              type="button"
                              size="sm"
                              className={
                                parc.CprPago ? 'bg-success' : 'bg-secondary'
                              }
                              // eslint-disable-next-line prettier/prettier
                              onClick={
                                () =>
                                  handlePagamento(
                                    `Parcela - ${parc.CprHistorico}`,
                                    parc.CprCodigo,
                                    parc.CprCodOrigem,
                                  )
                                // eslint-disable-next-line react/jsx-curly-newline
                              }
                            >
                              <FaCheckCircle size={14} />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <span>
                    <FaHistory size={15} /> <b>HISTÓRICO</b>
                  </span>
                  <ButtonAdd
                    type="button"
                    onClick={() => setShowModalComentario(true)}
                  >
                    <FaPlusCircle size={15} />
                  </ButtonAdd>
                </CardHeader>

                <CardBody style={{ height: '232px' }}>
                  <Table className="text-secondary" hover size="sm">
                    <thead>
                      <tr className="bg-light text-dark">
                        <th>Tipo</th>
                        <th>Colaborador</th>
                        <th>Comentário</th>
                        <th>Data</th>
                      </tr>
                    </thead>
                    <tbody>
                      {comentarios?.map(com => (
                        <tr key={`Cob-${com.ComCodigo}`}>
                          <td>{com.ComOrigemTexto}</td>
                          <td>{com.ComUsuNome}</td>
                          <td>{com.ComComentario}</td>
                          <td>{com.ComDataFormatado}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

export default CartaoSaudeDetalhe;
